import * as React from 'react';
import { Customer } from 'types/Customer';
import { UncontrolledAssignButton } from '../../../../customer-tag';

interface Props {
  setCustomer: (customer: Customer | null) => void;
}

export const SingleColumn: React.FC<Props> = (props) => {
  const { setCustomer } = props;

  return (
    <div className="space-y-1">
      <h4 className="font-bold">
        Add or create new Customer ID to apply to all containers (optional):
      </h4>
      <UncontrolledAssignButton onSelect={setCustomer} className="sticky" />
    </div>
  );
};
SingleColumn.displayName = 'CustomerAssignment.SingleColumn';
